<template>
  <v-container>
    <br/>
      <br/>
      <br/>
      <v-row>
        <v-spacer/>
        <v-img src="https://media.tenor.com/bS1qZ4npEywAAAAC/yes-cockroach.gif" heigth="25%" width="25%"/>
        <v-spacer/>
      </v-row>
      <br/>
      <br/>
    <v-row>
        <v-spacer/>
        <v-flex xs12 md5 ma-5>
          <v-btn
            color="primary"
            block
            x-large
            dark
            @click="$router.push('/ytbioad')"
          >
            YTBIOADB
          </v-btn>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 md5 ma-5>
          <v-btn
            color="primary"
            x-large
            block
            dark
            @click="$router.push('/rroob')"
          >
            RROOB
          </v-btn>
        </v-flex>
        <v-spacer/>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Spotify',
}
</script>